export const LOCALSTORAGEKEYS = {
    USERROLES: 'userRoles',
    SUBROLES: 'subRoles',
    USERPROFILE: 'userProfile',
    NATIONALPERMISSIONS: 'nationalPermissions',
    STATEPERMISSIONS: 'statePermissions',
    DISTRICTPERMISSIONS: 'districtPermissions',
    BLOCKPERMISSIONS: 'blockPermissions',
    APPLICATIONPERMISSIONS: 'applicationPermissions',
    CLF_MEETING_CONTEXT: 'clfMeetingContext',
    SELECTED_LANGUAGE: 'selectedLanguage',
};

export interface ClfMeetingContext {
    firstCLFSetup: boolean;
    newReqularMeeting: boolean;
    // Active geo-level tab selected on clf-meeting landing
    // (National | State | District | Block | CLF). Drives write-access gates.
    activeGeoLevel: string;
    // Meeting state
    meetingStatus: string;
    mtgType: number | null;
    meetingCnt: number;
    selectedMeetingNo: number | null;
    currMeetingNo: number | null;
    currentMeeting: number | null;
    meetingDetails: any | null;
    pastMeetingId: any | null;
    // Date validation
    lastMtgDate: string;
    lastMtgDateForContra: string;
    validateMeetingDateForContra: string;
    maxTxnDate: string;
    // CLF & bank
    cboBankDetails: any[];
    FederationDetails: any | null;
    clfDetails: any | null;
    // Fund data
    allFundsData: any[];
    fundPayload: any | null;
    // Listing
    allListingData: any[];
    // Cut-off meeting transaction data
    transactionObject: any | null;
    transactionObjectList: any | null;
    // Participants & meeting validation
    getParticipants: any | null;
    meetingListDateValidation: any | null;
}
